import { Directive, OnInit, Input, ElementRef, Renderer2 } from '@angular/core';
import { PlatformService } from '@app/core/services/platform.service';
declare let lazySizes;

@Directive({
  selector: '[appLazysizes]',
})
export class LazysizesDirective implements OnInit {
  public tempImage =
    'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
  @Input('appLazysizes') imgSrc: string;
  @Input() crop_ratio: number;
  public img: string;
  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private ps: PlatformService
  ) { }

  ngOnInit() {
    let query = 'width={width}';
    if (this.crop_ratio) {
      query = 'crop=smart&width={width}&height={height}';
    }
    this.img = `https://image.clancybriggs.co.uk/${this.imgSrc}?${query}`;
    this.initLazyLoading();
    this.setAttributes();
  }

  initLazyLoading() {
    if (this.ps.isBrowser && lazySizes) {
      lazySizes.init();
    }
  }

  setAttributes() {
    this.renderer.addClass(this.el.nativeElement, 'lazyload');
    if (
      this.el.nativeElement.localName === 'img' ||
      this.el.nativeElement.localName === 'source'
    ) {
      this.setImgSrc();
    } else {
      this.setElementBackgroundImage();
    }
  }

  setImgSrc() {
    this.renderer.setAttribute(this.el.nativeElement, 'data-src', this.img);
    this.renderer.setAttribute(this.el.nativeElement, 'data-sizes', 'auto');
    this.renderer.setAttribute(
      this.el.nativeElement,
      'data-widths',
      '[100, 320, 480, 640, 960, 1120, 1280]'
    );
    if (this.crop_ratio) {
      this.renderer.setAttribute(
        this.el.nativeElement,
        'data-aspectratio',
        this.crop_ratio.toString()
      );
    }
    this.renderer.setAttribute(this.el.nativeElement, 'src', this.tempImage);
  }

  setElementBackgroundImage() {
    this.renderer.setAttribute(this.el.nativeElement, 'data-bgset', this.img);
    this.renderer.setAttribute(this.el.nativeElement, 'data-sizes', 'auto');
    this.renderer.setStyle(
      this.el.nativeElement,
      'background-image',
      `url(${this.tempImage})`
    );
  }
}
